import { useEffect } from 'react';

/**
 * Компонент для динамического обновления head тегов (title, favicon, icons, manifest)
 * на основе настроек ресторана
 */
const RestaurantHead = ({ restaurantBranding, restaurantName, restaurantId }) => {
  useEffect(() => {
    // Обновляем title и иконки только если есть брендинг
    if (restaurantBranding) {
      // Обновляем title
      if (restaurantBranding.pageTitle) {
        document.title = restaurantBranding.pageTitle;
      } else if (restaurantName) {
        document.title = `${restaurantName} - Меню`;
      }

      // Функция для обновления или создания link тега
      const updateLinkTag = (rel, href, sizes = null, type = null) => {
        // Удаляем существующие теги с таким же rel и sizes
        const existing = document.querySelectorAll(`link[rel="${rel}"]${sizes ? `[sizes="${sizes}"]` : ''}`);
        existing.forEach(link => {
          if (!sizes || link.getAttribute('sizes') === sizes) {
            link.remove();
          }
        });

        // Создаем новый тег
        if (href) {
          const link = document.createElement('link');
          link.rel = rel;
          link.href = href;
          if (sizes) link.sizes = sizes;
          if (type) link.type = type;
          document.head.appendChild(link);
        }
      };

      // Обновляем favicon
      if (restaurantBranding.faviconUrl) {
        updateLinkTag('icon', restaurantBranding.faviconUrl);
      }

      // Обновляем Apple Touch Icon
      if (restaurantBranding.appleTouchIconUrl) {
        updateLinkTag('apple-touch-icon', restaurantBranding.appleTouchIconUrl, '180x180');
      }

      // Обновляем PWA иконки
      if (restaurantBranding.pwaIcon192Url) {
        updateLinkTag('icon', restaurantBranding.pwaIcon192Url, '192x192', 'image/png');
      }

      if (restaurantBranding.pwaIcon512Url) {
        updateLinkTag('icon', restaurantBranding.pwaIcon512Url, '512x512', 'image/png');
      }

      // Обновляем meta тег для Apple Mobile Web App Title
      if (restaurantBranding.pageTitle || restaurantName) {
        const title = restaurantBranding.pageTitle || restaurantName;
        let metaTitle = document.querySelector('meta[name="apple-mobile-web-app-title"]');
        if (!metaTitle) {
          metaTitle = document.createElement('meta');
          metaTitle.name = 'apple-mobile-web-app-title';
          document.head.appendChild(metaTitle);
        }
        metaTitle.content = title;
      }
    } else if (restaurantName) {
      // Даже без брендинга ставим базовый title
      document.title = `${restaurantName} - Меню`;
    }

    // Персональный манифест PWA для ресторана (иконки при установке)
    if (restaurantId) {
      const manifestHref = `/api/restaurant/${restaurantId}/manifest`;
      // Удаляем все старые manifest-ссылки
      const existingManifests = document.querySelectorAll('link[rel="manifest"]');
      existingManifests.forEach(link => link.parentNode.removeChild(link));

      const manifestLink = document.createElement('link');
      manifestLink.rel = 'manifest';
      manifestLink.href = manifestHref;
      document.head.appendChild(manifestLink);
    }

    // Cleanup function
    return () => {
      // Здесь специально ничего не откатываем, чтобы не мигали иконки/title при навигации
    };
  }, [restaurantBranding, restaurantName, restaurantId]);

  return null; // Компонент не рендерит ничего
};

export default RestaurantHead;
